import React from 'react';
import { Layout } from 'antd';
import InvitationViews from '../../views/invitation-views';

interface InvitationLayoutProps {}

const InvitationLayout = (props: InvitationLayoutProps) => {
  return (
    <Layout className="app-layout">
      <InvitationViews />
    </Layout>
  );
};

export default InvitationLayout;
